/**
 * Shared cross-link from S1 Neutralization Theorem cards to their Tier 1 root.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import { PRIMARY } from "../../design-system/tokens.js";
import type { ExplainerCrossLink } from "../shared/index.js";

export const TIER_ONE_IMMUNITY_LINK: ExplainerCrossLink = {
  label: "Categorical Immunity Theorem (Tier 1)",
  href: "#explainer-categorical-immunity",
  accent: PRIMARY[700],
};
